export const SINGLE_MODULE_MANIFEST = 'module.json';
export const MODULES_MANIFEST = 'modules.json';
export const INSTALL_MANIFEST = 'install.json';
export const FULL_FILE = 'full.zip';
export const BASE_FILE = 'base.zip';
export const DEFAULT_SPLIT_FILE_SIZE = 1_073_741_824;
